export default __webpack_public_path__ + "static/media/ramana.f24cc97e.png";